import { ReactNode } from 'react'
import './index.less'
import BackgroundBox from '../../BackgroundBox'

const AppraisalHeader = ({ noShadow = false, children }: { noShadow: boolean; children: ReactNode }): JSX.Element => {
  return (
    <BackgroundBox rt mb="xxs" className="appraisal-header" noShadow={noShadow} data-e2e-appraisal-header-footer>
      {children}
    </BackgroundBox>
  )
}
export default AppraisalHeader
